import React from "react";
import { Link } from "react-router-dom";

// Shared primary / secondary CTA. Renders as Link (internal) or anchor (external).
export function CTAButton({
  children,
  to,
  href,
  onClick,
  variant = "primary",
  size = "md",
  className = "",
  testId,
  type = "button",
  fullWidth = false,
  ...rest
}) {
  const base =
    "inline-flex items-center justify-center gap-2 font-semibold tracking-tight rounded-md transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-navy-900";
  const sizes = {
    sm: "text-sm px-4 py-2.5",
    md: "text-base px-6 py-3.5",
    lg: "text-base sm:text-lg px-8 py-4",
  };
  const variants = {
    primary:
      "bg-cta hover:bg-cta-dark text-white shadow-[0_8px_30px_rgba(249,115,22,0.25)] hover:scale-[1.03] focus:ring-cta",
    secondary:
      "bg-transparent border border-white/20 hover:border-white/50 text-white hover:bg-white/5 focus:ring-white/30",
    gold:
      "bg-gold hover:bg-[#c39d2c] text-navy-900 hover:scale-[1.03] focus:ring-gold",
    ghost:
      "bg-white/5 hover:bg-white/10 text-white border border-white/10 focus:ring-white/20",
  };
  const cls = `${base} ${sizes[size]} ${variants[variant]} ${fullWidth ? "w-full" : ""} ${className}`;

  if (to) {
    return (
      <Link to={to} className={cls} data-testid={testId} onClick={onClick} {...rest}>
        {children}
      </Link>
    );
  }
  if (href) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer" className={cls} data-testid={testId} onClick={onClick} {...rest}>
        {children}
      </a>
    );
  }
  return (
    <button type={type} className={cls} data-testid={testId} onClick={onClick} {...rest}>
      {children}
    </button>
  );
}

export default CTAButton;
